import { replace } from 'lodash';
import * as ActionTypes  from '../actions';

const defaultState = {};

export default function loaders(state = defaultState, action) {
  if (action.type === ActionTypes.API_FAILURE) {
    return {[action.type]: true};
  }

  const actionKey = replace(action.type, /(_RECEIVE|_REQUEST)/, '');

  if (/_RECEIVE$/.test(action.type)) {
    return {
      ...state,
      ...{
        [actionKey]: false,
        [ActionTypes.API_FAILURE]: false,
      },
    };
  }

  if (/_REQUEST$/.test(action.type)) {
    return {
      ...state,
      ...{
        [actionKey]: true,
        [ActionTypes.API_FAILURE]: false,
      },
    };
  }

  return state;
}
